<template>
  <div class="system-page" id="app" >
    <mt-header :title="'公文查阅'">
      <mt-button icon="back" slot="left" @click.native="goBack">返回</mt-button>
    </mt-header>
    <div v-if="isLoading" class="back-loading">数据加载中...</div>
    <div class="header" style="display: flex; align-items: center; padding: 0 0; background-color: #f5f5f5;position: sticky; top: 0">
      <div class="scrollable-content" id="scrollableContent" style="height: 700px;">
        <div style="width: 20rem;">
          <table class="bo table ">
            <tr >
              <td class="wi" style="width: 100px;" ><label style="margin-top: 10px;font-size:20px;height: 20px;color: #6d9eeb">来文单位</label></td>
              <td colspan="7" style="width:160px;"><div style="margin-top: 10px;font-size:20px;height: 40px;line-height: 20px">{{item.company}}</div></td>
            </tr>
            <tr >
              <td class="wi" style="width: 100px;" ><label style="margin-top: 10px;font-size:20px;height: 20px;color: #6d9eeb">文件原号</label></td>
              <td colspan="7" style="width:160px;"><div style="margin-top: 10px;font-size:20px;height: 40px;line-height: 20px">{{item.documentnum}}</div></td>
            </tr>
            <tr >
              <td class="wi" style="width: 100px;" ><label style="margin-top: 10px;font-size:20px;height: 20px;color: #6d9eeb">收文日期</label></td>
              <td colspan="7" style="width:160px;"><div style="margin-top: 10px;font-size:20px;height: 20px">{{item.applyTime}}</div></td>
            </tr>
            <tr >
              <td class="wi" style="width: 100px;" ><label style="margin-top: 10px;font-size:20px;height: 20px;color: #6d9eeb">文件标题</label></td>
              <td colspan="7" style="width:160px;"><div style="margin-top: 10px;font-size:20px;height: 80px;line-height: 20px">{{item.documentName}}</div></td>
            </tr>
            <tr class="rile">
              <td class="wi"><label style="margin-top: 10px;font-size:20px;height: 20px;color: #6d9eeb">附件</label></td>
              <td colspan="7" style="width:160px;">
                <div v-if="attachments.length!=0"style="width:260px;margin-top: 10px;font-size:20px;overflow-wrap: break-word; white-space: normal;line-height: 20px">
                  <div
                      v-for="(item, idx) in attachments"
                      :key="idx"
                      style="display: flex; align-items: center; margin-bottom: 5px;">
                    <span>{{ item.attachmentName }} <div class="nameusersub" @click.prevent="previewFile(item)">预览</div></span>
                  </div>

                </div>
                <div v-else  style="width:260px;margin-left: -262px;margin-top: 10px;font-size:20px;overflow-wrap: break-word; white-space: normal;line-height: 20px">
                  <div   style="display: flex; align-items: center; margin-bottom: 5px;margin-left: -40px">
                    <span>无文件</span>
                  </div>
                </div>
              </td>
            </tr>
            <tr class="rile" id="dynamicRow" style="height:150px;" v-if="item.statusId>29">
              <td colspan="14"  >
                <div>
                  <table >
                    <tr>
                      <td style="width:110px;text-align:center;background-color:#6d9eeb;height: 50px">
                        <div style="margin-top: 20px;font-size:20px;height: 30px;color: white">批示领导</div>
                      </td>
                      <td style="width:130px;text-align:center;background-color:#6d9eeb;height: 30px">
                        <div style="margin-top: 20px;font-size:20px;height: 30px;color: white">批示意见</div>
                      </td>
                      <td style="width:130px;text-align:center;background-color:#6d9eeb;height: 30px;">
                        <div style="margin-top: 20px;font-size:20px;height: 30px;color: white">是否批示</div>
                      </td>
                    </tr>
                    <tr v-for="(item, idx) in chooseShenList" :key="idx" style="margin-top: 60px">
                      <td style="width:110px;height:30px"><div style="font-size:20px;text-align:center;color: black;margin-top: 10px">{{item.userName}}</div></td>
                      <td style="width:130px;height:auto"><div style="font-size:20px;line-height: normal;text-align:center;color: black;margin-top: 10px">{{item.advice}}</div></td>
                      <td style="width:130px;height:30px"><div style="font-size:20px;text-align:center;color: black;margin-top: 10px">{{item.isshen==0?'是':'否'}}</div></td>
                    </tr>
                  </table>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import tabModule from "@/components/footerBar/index.vue";
import { getLocalData } from "@/utils/sessionData.js";
import { saveAs } from 'file-saver'
import request from "@/utils/keyCloakRequest";
import axios from "axios";
import {Toast} from "mint-ui";
export default {
  components: {
    "v-tab-module": tabModule,
  },
  beforeMount() {},
  data() {
    return {
      chooseShenList:{},
      item:{},
      route:'',
      isLoading: false,
      attachments:[],
    };
  },
  async created() {
    this.item = this.$route.query.item;
    this.route =  this.$route.query.route
    await this.getChooseShenList()
    const heightPerItem = 30; // 每个元素增加的高度
    if(this.chooseShenList.length>0){
      const trElement = document.getElementById('dynamicRow');
      const newHeight = 10 + (this.chooseShenList.length * heightPerItem);
      trElement.style.height = `${newHeight}px`;
    }
    const contentElement = document.getElementById('scrollableContent');
    const newContentHeight = 700 + (this.chooseShenList.length * heightPerItem);
    contentElement.style.height = `${newContentHeight}px`;
    if(this.item.fileId!=null){
      request({
        url: "appDocumentFile?fileIds="+this.item.fileId,
        method: "get"
      }).then(  response => {
        this.attachments = response
      })
    }
  },
  mounted() {
  },

  methods: {
    getChooseShenList(){
      request({
        url: "appChooseShenList?documentId="+this.item.documentId,
        method: "get"
      }).then(  response => {
        this.chooseShenList = response
      })

    },
    previewFile(attachment){
      this.$router.push({
        name: 'filePreview',
        query: {
          attachment: attachment,
          item: this.item,
          route:this.route,
          name:'deptDocumentListDetail'
        },
      });
    },
    goBack() {
      this.$router.push(this.route);
    },
  },
};
</script>

<style lang="less">
@color: #ffffff;
@border-rd: 0.6rem;

html {
  overflow: hidden;
  height: 100%;
  background: #f5f5f5;
}
.nameusersub{
  width: 40%;
  height: 100px;
  line-height: 100px;
  background: #5cb85c;
  border-radius: 50px 50px 50px 50px;
  text-align: center;
  cursor: pointer;
  color: #e5f4f9;
}
body {
  display: block;
  margin: 0rem !important;
}
.app {
  /* padding: 0.5rem; */
  background-color: rgb(240, 240, 240, 0.75);
}
.menuTitle {
  font-size: 1rem;
}
.system-page {
  width: 100%;
  height: 100vh;
  background-color: #f1f5f8;
  font-family: "PingFangSC-Regular";
}
.sub {
  width: 100%;
  height: 200px;
  line-height: 200px;
  font-size: 75px;
  background: #5f9cf5;
  border-radius: 50px 50px 50px 50px;
  text-align: center;
  cursor: pointer;
  color: #e5f4f9;
  margin-top: 100px;
}
/** 加载中 */
.back-loading {
  width: 100%;
  height: 100%;
  background-color: white;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  text-align: center;
  line-height: 25rem;
  font-size: 1rem;
  color: grey;
}
</style>
